/**
 * Created by chao on 2019/3/1.
 */

// 格式化时间戳
const formDate = (value, hasTime) => {
    if (!value) return "";
    if (value.toString().length !== 13) {
        value = value * 1000;
    }
    const date = new Date(value);
    let result = "";
    let Y = date.getFullYear() + "-";
    let M =
        (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1) + "-";
    let D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    result = Y + M + D;
    if (hasTime) {
        let h =
            (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
        let m =
            (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
            ":";
        let s =
            date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        result += " " + h + m + s;
    }
    return result;
};

const timeFormat = value => {
    if (Array.isArray(value)) {
        let temp = [];
        value.forEach(e => {
            temp.push(formDate(e / 1000));
        });
        return temp.join(" - ");
    } else {
        return value;
    }
};

const dateCalculation = second => {
    // 返回天、时、分
    if (typeof second === "number" && second.toString().length === 13) {
        second = second / 1000;
    } else {
        second = parseInt(second);
    }
    if (second > 0) {
        let day = 0;
        let hour = 0;
        let minute = 0;
        let data = {};
        minute = Math.floor(second / 60);
        if (parseInt(minute) > 60) {
            hour = parseInt(minute / 60);
            minute %= 60; // 算出有多分钟
        }
        if (parseInt(hour) > 24) {
            day = parseInt(hour / 24);
            hour %= 24; // 算出有多分钟
        }
        data.day = day;
        data.hour = hour;
        data.minute = minute;
        let newTime = "";
        if (day) {
            newTime = day + "天" + hour + "时" + minute + "分";
        } else if (hour) {
            newTime = hour + "时" + minute + "分";
        } else if (minute) {
            newTime = minute + "分";
        }
        return newTime;
    }
};

// 数组去重
const disTinct = value => {
    let result = [];
    for (let i = 0; i < value.length; i++) {
        for (let j = i + 1; j < value.length; j++) {
            if (value[i] === value[j]) {
                j = ++i;
            }
        }
        result.push(value[i]);
    }
    return result;
};

const isInArray = (arr, value) => {
    if (!(arr instanceof Array)) {
        return false;
    }
    for (let i = 0; i < arr.length; i++) {
        if (value === arr[i]) {
            return true;
        }
    }
    return false;
};

// 判断手机号
const isAvailable = pone => {
    var myreg = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;
    if (!myreg.test(pone)) {
        return false;
    } else {
        return true;
    }
};

// 获取参数
const getUrlParam = paraName => {
    let url = document.location.toString();
    let arrObj = url.split("?");
    if (arrObj.length > 1) {
        let arrPara = arrObj[1].split("&");
        let arr;
        for (let i = 0; i < arrPara.length; i++) {
            arr = arrPara[i].split("=");

            if (arr != null && arr[0] == paraName) {
                return decodeURI(arr[1]);
            }
        }
        return "";
    } else {
        return "";
    }
};
/**
 * 字节转 TB KB等
 * @param {*} bytes
 */
const bytesToSize = bytes => {
    bytes = Number(bytes) || 0;
    if (bytes === 0) return "0 B";
    let k = 1000, // or 1024
        sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
        i = Math.floor(Math.log(bytes) / Math.log(k));

    return (bytes / Math.pow(k, i)).toPrecision(3) + " " + sizes[i];
};
/**
 * 补零
 * @param str
 */
function padLeftZero(str) {
    return ("00" + str).substr(str.length);
}
/**
 * 时间格式化
 * @param date
 * @param fmt
 */
const formatDate = (date, fmt) => {
    if (date === "" || typeof date === "undefined") {
        return "--";
    } else {
        date = new Date(date);
        if (/(y+)/.test(fmt)) {
            fmt = fmt.replace(
                RegExp.$1,
                (date.getFullYear() + "").substr(4 - RegExp.$1.length)
            );
        }
        const o = {
            "M+": date.getMonth() + 1,
            "d+": date.getDate(),
            "h+": date.getHours(),
            "m+": date.getMinutes(),
            "s+": date.getSeconds()
        };
        for (const k in o) {
            if (new RegExp(`(${k})`).test(fmt)) {
                const str = o[k] + "";
                fmt = fmt.replace(
                    RegExp.$1,
                    RegExp.$1.length === 1 ? str : padLeftZero(str)
                );
            }
        }
        return fmt;
    }
};

/**
 * 秒 转 00:00:00
 * @param {*} times
 */
function timeToMinute(times) {
    let result = "00:00:00";
    let hour, minute, second;
    if (times > 0) {
        hour = Math.floor(times / 3600);
        if (hour < 10) {
            hour = "0" + hour;
        }
        minute = Math.floor((times - 3600 * hour) / 60);
        if (minute < 10) {
            minute = "0" + minute;
        }

        second = Math.floor((times - 3600 * hour - 60 * minute) % 60);
        if (second < 10) {
            second = "0" + second;
        }

        result = hour + ":" + minute + ":" + second;

        // if (hour == "00") {
        //   result = minute + ":" + second;
        // } else if (minute == "00") {
        //   result = hour + ":" + minute + ":" + second;
        // } else {
        //   result = second;
        // }
    }
    return result;
}

function secondToDate(msd) {
    // var time = parseFloat(msd);
    let time = Number(msd) || 0;
    if (null != time && "" != time) {
        if (time > 60 && time < 60 * 60) {
            time =
                parseInt(time / 60.0) +
                "分钟" +
                parseInt((parseFloat(time / 60.0) - parseInt(time / 60.0)) * 60) +
                "秒";
        } else if (time >= 60 * 60 && time < 60 * 60 * 24) {
            time =
                parseInt(time / 3600.0) +
                "小时" +
                parseInt((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60) +
                "分钟" +
                parseInt(
                    (parseFloat(
                        (parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60
                    ) -
                        parseInt(
                            (parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60
                        )) *
                    60
                ) +
                "秒";
        } else {
            time = parseInt(time) + "秒";
        }
    }
    if (time == 0) {
        time = "0秒";
    }
    return time;
}

/**
 * 获取指定日期为几天前
 * @param {*} dateTimeStamp
 */
function getDateDiff(dateTimeStamp) {
    const minsecond = dateTimeStamp * 1000;
    const data = new Date(minsecond);
    dateTimeStamp = data.getTime();
    let minute = 1000 * 60;
    let hour = minute * 60;
    let day = hour * 24;
    let halfamonth = day * 15;
    let month = day * 30;
    let now = new Date().getTime();
    let diffValue = now - dateTimeStamp;
    let result = "";
    // console.log("diffValue", minsecond, dateTimeStamp, diffValue);
    if (diffValue < 0) {
        return;
    }
    let monthC = diffValue / month;
    let weekC = diffValue / (7 * day);
    let dayC = diffValue / day;
    let hourC = diffValue / hour;
    let minC = diffValue / minute;
    if (monthC >= 1) {
        result = "" + parseInt(monthC) + "月前";
    } else if (weekC >= 1) {
        result = "" + parseInt(weekC) + "周前";
    } else if (dayC >= 1) {
        result = "" + parseInt(dayC) + "天前";
    } else if (hourC >= 1) {
        result = "" + parseInt(hourC) + "小时前";
    } else if (minC >= 1) {
        result = "" + parseInt(minC) + "分钟前";
    } else result = "刚刚";
    return result;
}
/**
 * 提交代码 获取指定时间是当前日期的几天后
 * @param {*} dateTimeStamp
 */
function getDateEnd(dateTimeStamp) {
    dateTimeStamp = new Date(dateTimeStamp * 1000).getTime();
    let minute = 1000 * 60;
    let hour = minute * 60;
    let day = hour * 24;
    let halfamonth = day * 15;
    let month = day * 30;
    let now = new Date().getTime();
    let diffValue = dateTimeStamp - now;
    let result = "";
    if (diffValue < 0) {
        return "";
    }
    let monthC = diffValue / month;
    let weekC = diffValue / (7 * day);
    let dayC = diffValue / day;
    let hourC = diffValue / hour;
    let minC = diffValue / minute;
    if (monthC >= 1) {
        result = "" + parseInt(monthC) + "月";
    } else if (weekC >= 1) {
        result = "" + parseInt(weekC) + "周";
    } else if (dayC >= 1) {
        result = "" + parseInt(dayC) + "天";
    } else if (hourC >= 1) {
        result = "" + parseInt(hourC) + "小时";
    } else if (minC >= 1) {
        result = "" + parseInt(minC) + "分钟";
    } else result = "";
    return result;
}

export {
    formDate,
    timeToMinute,
    formatDate,
    timeFormat,
    getDateDiff,
    getDateEnd,
    disTinct,
    isInArray,
    isAvailable,
    getUrlParam,
    bytesToSize,
    dateCalculation,
    secondToDate
};
